import { Filter } from "@/types/filters";

export const defaultSelectedOutputFilters = ["businessGoalPropertyValue", "plan", "scenario", "mediaType"];

export type ScenarioNode = {
  id: string;
  label: string;
  children?: ScenarioNode[];
};

export type ProjectOutputFilterParams = {
  scenario: string[] | ScenarioNode[] | null;
  plan: string[] | null;
  mediaType: string[] | null;
  businessGoalPropertyValue: string[] | null;
};

export const defaultPlanOutputFilterValues: ProjectOutputFilterParams = {
  plan: ["All"],
  scenario: ["All"],
  businessGoalPropertyValue: ["All"],
  mediaType: ["All"],
};

export const planOutputFilters: Array<Filter> = [
  {
    label: "Business Goal",
    filterName: "MultipleSelectFilter",
    filterKey: "businessGoalPropertyValue",
    apiKey: "business_goal_property_values",
    value: null,
    isPageDetails: true,
    items: [{ text: "All", value: null }],
  },
  {
    label: "Plan",
    filterName: "MultipleSelectFilter",
    filterKey: "plan",
    apiKey: "plans",
    value: null,
    items: [{ text: "All", value: null }],
  },
  {
    label: "Scenario",
    filterName: "PlanScenarioTreeSelectFilter",
    filterKey: "scenario",
    apiKey: "scenarios",
    value: null,
    items: [{ text: "All", value: null }],
  },
  {
    label: "Media Type",
    filterName: "MultipleSelectFilter",
    filterKey: "mediaType",
    apiKey: "mediaType",
    value: null,
    items: [{ text: "All", value: null }],
  },
];
